import React from 'react';
import PropTypes from 'prop-types';
import {fetchApiDataFailure} from "../../../../_actions/common.actions";

export default class ComponentOM extends React.Component{
    static get propTypes() {
        return {
            collectionId: PropTypes.string,
            getOMs: PropTypes.func.isRequired,
            resourceIds: PropTypes.array.isRequired
        };
    }

    constructor (props) {
        super(props);
        this.state = {
            oms: []
        };
        this.getOMS = this.getOMS.bind(this);
    }

    componentDidMount() {
        if (this.props.resourceIds) {
            this.getOMS(this.props.resourceIds);
        }
    }

    componentWillReceiveProps(nextProps){
        if (nextProps.resourceIds !== this.props.resourceIds){
            this.getOMS(nextProps.resourceIds);
        }
    }

    getOMS(collectionId) {
        this.props.getOMs(collectionId)
            .then(response => {
                this.setState({
                    oms: response.data
                });
            })
            .catch(error => {
                fetchApiDataFailure(error);
            });
    }

    render() {
        return (
            <div className="om-component-container">
                <h4>OM</h4>
                <div className="row">
                    <div className="row header">
                        <div id="1" className="col3">Content</div>
                        <div id="2" className="col3">Content Type</div>
                        <div id="3" className="col1">Type</div>
                        <div id="4" className="col2">File</div>
                        <div id="5" className="col1">Trim Size</div>
                    </div>
                    {(this.state.oms) ?
                        <div>
                            {this.state.oms.map((om) => (
                                <div className="om-item">
                                    <div className="row">
                                        <div id="1" className="col3">{om.title}</div>
                                        <div id="2" className="col3">PDF</div>
                                        <div id="3" className="col1">{om.resourceType}</div>
                                        <div id="4" className="col2">
                                            <div className="file">
                                                <div><img src="/digitaladmin/images/pdf.png" alt="PDF Icon"/></div>
                                                <div className="link">
                                                    <a href={om.fileUrl} target="_blank">{om.fileName+"("+om.fileSize+")"}</a>
                                                </div>
                                            </div>
                                        </div>
                                        <div id="5" className="col1">{om.trimSize}</div>
                                    </div>
                                    <hr/>
                                </div>
                            ))}
                        </div>
                        : null}

                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/ComponentPageComponents/ComponentOM.js